import { SdkActions, SdkEvents, SdkSources } from 'sdk/enums';

export default function openRegistrationScreen() {
  return {
    data: { source: SdkSources.DRIVE, action: SdkActions.CLICK, hideSocialActions: true },
    event: SdkEvents.OPEN_REGISTRATION_SCREEN,
  };
}
